import { Checkbox } from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import FieldLabel from 'src/components/FieldLabel/FieldLabel'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface ExactPayBoxProps {
  isSelected?: boolean
  tooltip?: React.ReactElement
  onClick?: () => void
}

const ExactPayBox: React.FC<ExactPayBoxProps> = (props): React.ReactElement => {
  return (
    <Box>
      <FieldLabel>
        <Trns source={'Exact Pay'} />
      </FieldLabel>
      {props.tooltip !== undefined && props.tooltip}
      <Checkbox
        label={<Trns source={'Transaction amount must match credit limit'} />}
        isSelected={props.isSelected !== undefined ? props.isSelected : false}
        onClick={props.onClick}
        css={css`
          margin-top: 20px;
        `}
      />
    </Box>
  )
}

export default ExactPayBox
